<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" v-if="version">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
            <div class="d-flex justify-content-between align-items-start">
                <div class="title m-0">
                    <h1 class="text-black fw-medium mb-8">{{ version.title }}</h1>
                    <span class="d-block text-dark-emphasis mb-0 small">
                        {{ version.revision_number }}
                    </span>
                </div>
                <button
                    class="default-btn transition outlined fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
                    type="button" @click="restore">
                    {{ $t('cta.restore_consent_version') }}
                </button>
            </div>
            <div class="border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30"></div>
            <!-- BODY -->
            <div class="mb-15" v-html="version.body"></div>
            <!-- MANDATORY -->
            <div class="form-check form-group form-check mb-15  pointer-event-none">
                <input class="form-check-input shadow-none me-8" type="checkbox" :checked="version.mandatory"
                    id="mandatory">
                <label class="form-check-label fw-medium position-relative top-1" for="mandatory">
                    {{ $t('form.mandatory.label') }}
                </label>
            </div>
            <div v-if="version.mandatory && version.mandatory_message">
                {{ version.mandatory_message }}
            </div>
            <div class="mb-25"></div>
            <!-- HAS CHECKBOX -->
            <div class="form-check form-group form-check mb-15  pointer-event-none" v-if="version.has_checkbox">
                <input class="form-check-input shadow-none me-8" type="checkbox"
                    id="mandatory">
                <label class="form-check-label fw-medium position-relative top-1" for="mandatory">
                    <!-- {{ $t('form.has_checkbox.label') }} -->
                    {{ version.checkbox_disclaimer }}
                </label>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Consent, ConsentVersion } from '@/utils/models/consent.model';
import { defineComponent } from 'vue';

export default defineComponent({
    name: "ConsentVersionInfo",
    data() {
        console.log(this.$route.meta);
        return {
            consent: this.$route.meta.consent as Consent | undefined,
            version: this.$route.meta.consent_version as ConsentVersion | undefined,
        }
    },
    methods: {
        restore() {
            this.$router.replace({
                path: `/consent/${this.version?.consent_id}/version/${this.version?.id}/restore`,
            });
        }
    }
})
</script>